import React, {Component} from 'react';
import LazyLoad from 'react-lazyload';
import PropTypes from 'prop-types';

import {Card} from 'semantic-ui-react';

import Player from '../Player';

import './Video.css';

export default class CardVideo extends Component {

    shouldComponentUpdate({video: {
            url
        }}) {
        return url !== this.props.video.url;
    }

    render() {
        const {video: {
                url
            }} = this.props;
        return <Card className="CardVideo" fluid={true}>
            <LazyLoad unmountIfInvisible={true} offset={320} throttle={true}>
                <Player className="CardVideo-player" url={url}/>
            </LazyLoad>
        </Card>;
    }
}

CardVideo.propTypes = {
    video: PropTypes
        .shape({
            url: PropTypes
                .oneOfType([PropTypes.string, PropTypes.array])
                .isRequired
        })
        .isRequired
};


// WEBPACK FOOTER //
// ./src/components/card/Video.js